var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCooling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7732 6.2L4.22675 11.8M13.7732 6.2L14.6378 2.92154M13.7732 6.2L17 7.07846M4.22675 11.8L1 10.9215M4.22675 11.8L3.36214 15.0785M13.7732 11.7999L4.22668 6.19988M13.7732 11.7999L17 10.9214M13.7732 11.7999L14.6379 15.0784M4.22668 6.19988L3.36226 2.92163M4.22668 6.19988L1.00011 7.07855M9 3.4L9 14.6M9 3.4L6.63785 1M9 3.4L11.3621 1M9 14.6L6.63785 17M9 14.6L11.3621 17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooling);
export default __webpack_public_path__ + "static/media/Cooling.99cdde4c.svg";
export { ForwardRef as ReactComponent };